"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const margin_1 = require("./margin");
class Interval {
    constructor(intervalJson) {
        this.lowerMargin = intervalJson.lowerMargin
            ? new margin_1.Margin(intervalJson.lowerMargin)
            : undefined;
        this.higherMargin = intervalJson.higherMargin
            ? new margin_1.Margin(intervalJson.higherMargin)
            : undefined;
    }
    limitNumber(num) {
        if (this.lowerMargin && num < this.lowerMargin.margin) {
            return this.lowerMargin.margin;
        }
        else if (this.higherMargin && num > this.higherMargin.margin) {
            return this.higherMargin.margin;
        }
        else {
            return num;
        }
    }
}
exports.Interval = Interval;
//# sourceMappingURL=interval.js.map